module.exports = __webpack_public_path__ + "img/winner-prize.ab97596b.png";